import React from 'react';
import '../styles/Accommodations.css';

const Accommodations = ({ stays, isLoading, openLightbox, openBooking }) => {
  return (
    <section id="accommodations" className="py-24 px-6 nature-texture">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="text-emerald-600 font-bold uppercase tracking-[0.2em] text-[10px] md:text-xs">Authentic Forest Living</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-2 text-emerald-950">Our Handcrafted Stays</h2>
          <div className="w-16 md:w-20 h-1 bg-emerald-600 mx-auto mt-4 md:mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10 pt-10">
          {isLoading ? (
            Array.from({ length: 3 }).map((_, idx) => (
              <div 
                key={`skeleton-${idx}`} 
                className="bg-white p-4 organic-card shadow-sm border border-emerald-100 animate-pulse"
              >
                <div className="rounded-[30px] h-56 sm:h-72 mb-4 md:mb-6 bg-gray-200"></div>
                <div className="px-2 pb-4">
                  <div className="h-6 md:h-8 bg-gray-200 rounded mb-2 md:mb-3 w-3/4"></div>
                  <div className="h-4 bg-gray-200 rounded mb-2 w-full"></div>
                  <div className="h-4 bg-gray-200 rounded mb-4 md:mb-6 w-5/6"></div>
                  <div className="h-12 bg-gray-200 rounded-2xl w-full"></div>
                </div>
              </div>
            ))
          ) : (
            stays.map((stay, idx) => (
              <div 
                key={stay.id || idx} 
                className="bg-white p-4 organic-card shadow-sm border border-emerald-100 group cursor-pointer"
                onClick={() => openLightbox(0, stay.gallery)}
              >
                <div className="overflow-hidden rounded-[30px] h-56 sm:h-72 mb-4 md:mb-6 relative">
                  <img src={stay.gallery[0]} alt={stay.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition duration-700" />
                  <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                     <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-full border border-white/30 text-white text-xs font-bold uppercase tracking-widest">
                       <i className="fas fa-expand-arrows-alt mr-2"></i> View Gallery
                     </div>
                  </div>
                </div>
                <div className="px-2 pb-4">
                  <h3 className="text-xl md:text-2xl font-bold text-emerald-950 mb-2 md:mb-3">{stay.title}</h3>
                  <p className="text-gray-500 text-sm mb-4 md:mb-6 leading-relaxed">
                    {stay.desc}
                  </p>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      openBooking(stay);
                    }} 
                    className="flex items-center justify-between w-full bg-emerald-600 text-white border border-emerald-600 hover:bg-white hover:text-emerald-600 font-bold py-3 px-6 rounded-2xl transition-all duration-300 text-sm shadow-lg shadow-emerald-200"
                  >
                    Book Now <i className="fas fa-chevron-right text-[10px]"></i>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Accommodations;
